<template>
  <div class="asd-form-section">
    <div class="section-title">
      <h5>
        <i class="fas fa-bullseye"></i>
        Stavy
      </h5>
      <div class="section-title-controls">
        <ActiveButton class="asd-btn-confirm asd-btn-single-icon"
                      :click="save"
        >
          <i class="fas fa-save"></i>
        </ActiveButton>
      </div>
    </div>
    <table class="asd-table">
      <thead>
        <tr class="table-heading">
          <th>
            <button class="asd-btn-confirm asd-btn-single-icon"
                    @click="addState"
            >
              <i class="fas fa-plus"></i>
            </button>
          </th>
          <th>
            Název
          </th>
          <th>
            Barva
          </th>
          <th>
            Skupina
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(s, i) in states"
            :key="s.id"
        >
          <td class="asd-btn-group">
            <button type="button"
                    class="asd-btn-delete"
                    @click="deleteState(i)"
            >
              <i class="far fa-trash-alt"></i>
            </button>
          </td>
          <td>
            <input v-model="s.label"
                   class="asd-input"
                   type="text"
                   required
            />
          </td>
          <td>
            <ColorSelect v-model="s.color"></ColorSelect>
          </td>
          <td>
            <Multiselect
              :id="`group-${s.id}`"
              v-model="s.group"
              :max="1"
              label="label"
              trackBy="id"
              valueByPath="id"
              :options="stateGroups"
              :returnAsSingle="true"
              :allowEmpty="false"
            >
            </multiselect>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { get, has } from 'lodash'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import ColorSelect from 'CORE/components/form/input/color-select'
import { createEmptyState } from './defaultObjects'
import stateGroups from 'ENUMS/entity-states-groups'
import ActiveButton from 'CORE/components/form/active-button'

export default {
    name: 'Filename',
    components: {
        Multiselect,
        ColorSelect,
        ActiveButton,
    },
    props: {
    },
    data() {
        return {
            states: [],
        }
    },
    computed: {
        stateGroups() {
            return stateGroups
        },
    },
    mounted() {
        this.states = get(this.$store.getters.settings, `entity-states.states`, [])
    },
    methods: {
        addState() {
            this.states.push(createEmptyState())
        },
        deleteState(index) {
            this.$delete(this.states, index)
        },
        async save() {
            const data = this.$store.getters.settings
            if (!has(data, 'entity-states')) {
                this.$set(data, 'entity-states', {})
            }
            data['entity-states']['states'] = this.states
            try {
                await this.$store.dispatch('saveCurrentUserCompanySettings', data)
                this.flash('Uloženo', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
    },
}
</script>

<style scoped>

</style>

